/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {
  useState, useEffect,
} from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import styled from '@emotion/styled';
import ResizeObserver from 'react-resize-observer';
import { toast } from 'react-toastify';
import { Field } from 'formik';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import Input from '../../../../shared/_TBComponents/Input/index';
import VideoAndUrlInput from './VideoAndUrlInputs';
import SelectBox from '../../../../shared/_TBComponents/SelectBox/index';
import { setActiveSecondLayerModal, fetchDocument, addAsset } from '../../ducks/calendarActions';

const DescriptionContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const CircuitsInputsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const AdditionalOptionsHeaderRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const AdditionalOptionsTextAndArrowIconContainer = styled('div')`
 display: flex;
 align-items: center;
 cursor: pointer;
 gap: 8px;
 transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const Seperator = styled('div')`
  display: flex;
  width: 100%;
  height: 1px;
  background: #EEEEEE;
`;

const CircuitsInputsRow = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 528 ? 'column' : 'row')};
  gap: 32px;
`;

const CircuitsInputsSubContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

const InputTypeAndPRTrackingContainer = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 840 ? 'column' : 'row')};
  gap: 16px;
`;

const OuterLinkContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

const StyledTextArea = styled('textarea')`
  width: 100%;
  height: 100%;
  min-height: 82px !important;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: 'Nunito Sans';
  color: #444444;
  &:focus {
    outline: none;
    border-color: #ccc;
    box-shadow: none;
  }
  ::placeholder {
    color: #9E9E9E;
  }

  :disabled {
    background: white;
    border-color: #EEEEEE;
    color: #BDBDBD;
  }
`;

const AddAssetButtonContainer = styled('div')`
  display: flex;
  gap: 4px;
  cursor: pointer;
  align-items: center;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const AssetButtonContainer = styled('div')`
  position: relative;
  display: flex;
  gap: 4px;
  border: 1px solid #EEEEEE;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  cursor: pointer;
  align-items: center;
  border-radius: 4px;
  width: fit-content;
`;

const ClearAssetIconContainer = styled('div')`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: #E0E0E0;
  padding: 4px;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const NameAndInputContainer = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  .checkbox-input {
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid #E0E0E0;
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    position: relative;
    transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
  }

  .checkbox-input:checked {
    border: ${(props) => (props.disabled ? '2px solid #E0E0E0' : '2px solid #77A7FF')};
   }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: ${(props) => (props.disabled ? 'solid #E0E0E0' : 'solid #77A7FF')};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }
`;

const CheckBoxRow = styled('div')`
 display: flex;
 flex-wrap: wrap;
 gap: 16px;
`;

const LabelAndCheckBoxContainerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AdditionalOptionsWrapper = styled('div')`
  display: flex;
  gap: 16px;
  margin-top: -9px;
  transition: ${TransitionGlobal};
  overflow: hidden;
  max-height: ${(props) => (!props.showAdditionalOptions ? '0px' : '500px')};
`;

const AddAssetsColumn = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const CompleteContainer = styled('div')`
  display: flex;
  align-items: flex-end;
  width: 100%;
  input {
    border-bottom-left-radius: 0px !important;
    border-top-left-radius: 0px !important;
    border-color: ${(props) => !!props.touched && props.error && '#CC0404'};
  }
`;

const CompleteContainerAndErrorWrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-end;
`;

const CircuitsFormInputs = ({
  errors,
  touched,
  handleChange,
  videoUrlValue,
  mediaUrlValue,
  trackingValue,
  linkToValue,
  setFieldValue,
  handleBlur,
  setFieldTouched,
  setFieldError,
  urlButtonValue,
  containerWidth,
  coachCompletionValue,
  setTouched,
  prSortOrderValue,
  reusableItemValue,
  detailValue,
  inputTypeValue,
  detailTypeValue,
  /** documentId, */
  /** documentUrl, */
}) => {
  const dispatch = useDispatch();
  const assetToAdd = useSelector((state) => state.calendar.data.addAsset);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const accountCode = currentUser?.accountCode;
  const modalData = useSelector((state) => state.calendar.data.modalData);
  const [showAdditionalOptions, setShowAdditionalOptions] = useState(true);
  const [addAssetsColumnContainerWidth, setAddAssetsColumnContainerWidth] = useState(0);

  useEffect(() => {
    if (assetToAdd) {
      setFieldValue('documentId', assetToAdd?.id);
    }
  }, [assetToAdd]);

  const PRTrackingOptions = [
    {
      name: 'Disabled',
      id: 0,
      includeCheckmark: prSortOrderValue === 0,
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Higher Value is Better',
      id: 1,
      includeCheckmark: prSortOrderValue === 1,
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Lower Value is Better',
      id: 2,
      includeCheckmark: prSortOrderValue === 2,
      checkmarkColor: '#BDBDBD',
    },
  ];

  const inputTypeOptions = [
    {
      name: 'Sets',
      id: 'S',
      includeCheckmark: inputTypeValue === 'S',
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Reps',
      id: 'R',
      includeCheckmark: inputTypeValue === 'R',
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Time',
      id: 'T',
      includeCheckmark: inputTypeValue === 'T',
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'None(Completion Only)',
      id: 'C',
      includeCheckmark: inputTypeValue === 'C',
      checkmarkColor: '#BDBDBD',
    },
  ];

  const detailTypeOptions = [
    {
      name: 'Sets',
      id: 'sets',
      includeCheckmark: inputTypeValue === 'sets',
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Reps',
      id: 'reps',
      includeCheckmark: inputTypeValue === 'reps',
      checkmarkColor: '#BDBDBD',
    },
  ];

  const AthleteInputCheckBoxDataArray = [
    {
      name: 'coachCompletion',
      label: 'Coach Completion',
      checked: coachCompletionValue,
    },
  ];

  const customSelectStylesLinkTo = {
    control: (provided, state) => ({
      ...provided,
      borderTopRightRadius: state.options.some((option) => option.id === 'sets') && '0px',
      borderBottomRightRadius: state.options.some((option) => option.id === 'sets') && '0px',
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 400,
      background: state.options.some((option) => option.id === 'sets') ? '#FCFCFC' : 'white',
      borderColor: state.isFocused ? 'lightgray' : 'lightgray',
      boxShadow: state.isFocused ? 'none' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? 'lightgray' : 'lightgray',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '4px',
      backgroundColor: 'white',
      color: state.isSelected || ((linkToValue === 'none' || linkToValue === null) && state.data.id === 'none') || (trackingValue === 0 && state.data.id === 0) ? '#BDBDBD' : '#444444',
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      marginBottom: '8px',
      fontWeight: state.data.__isNew__ ? 700 : 400,
      '&:hover': {
        backgroundColor: '#FCFCFC',
      },
      paddingLeft: state.data.isGrouped && '12px',
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: '#FCFCFC',
      border: '1px solid #EEEEEE',
      borderRadius: '4px',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: '#444444',
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: '#9E9E9E',
    }),
    menu: (provided) => ({
      ...provided,
      border: '0px',
      minWidth: '250px',
      padding: '16px',
      marginTop: '0px',
      marginBottom: '0px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '500px',
    }),
    group: (provided) => ({
      ...provided,
      padding: '0px',
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: '16px',
      fontWeight: 700,
      color: '#9E9E9E',
      paddingLeft: '0px',
      paddingRight: '0px',
      marginBottom: '8px',
      fontFamily: 'Nunito Sans',
      textTransform: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9E9E9E',
    }),
    input: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? 'inherit' : provided.color, /** Use 'inherit' to maintain original color */
    }),
  };

  return (
    <CircuitsInputsContainer>
      <CircuitsInputsRow containerWidth={containerWidth}>
        <VideoAndUrlInput
          errors={errors}
          touched={touched}
          videoUrlValue={videoUrlValue}
          mediaUrlValue={mediaUrlValue}
          setFieldValue={setFieldValue}
          urlButtonValue={urlButtonValue}
          containerWidth={containerWidth}
          setFieldTouched={setFieldTouched}
          setFieldError={setFieldError}
          isDisabled={modalData?.disabledEditModal}
        />
        <CircuitsInputsSubContainer>
          <NameAndInputContainer disabled={modalData?.disabledEditModal}>
            <input
              disabled={modalData?.disabledEditModal}
              className='checkbox-input'
              type='checkbox'
              name='reusableItem'
              onChange={() => {
                setFieldValue('reusableItem', !reusableItemValue);
                /** if the user goes to uncheck save to database we need to set
                 * prSortOrder value back to 0 if there is one and we need to hide
                 * prSortOrder as an input option
                 */
                if (reusableItemValue) {
                  setFieldValue('prSortOrder', 0);
                }
              }}
              checked={reusableItemValue}
            />
            <Text color={modalData?.disabledEditModal && '#BDBDBD'} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>Save to Database</Text>
          </NameAndInputContainer>
          <OuterLinkContainer>
            <InputTypeAndPRTrackingContainer containerWidth={containerWidth}>
              <SelectBox
                isDisabled={modalData?.disabledEditModal}
                options={inputTypeOptions}
                value={inputTypeOptions.find((option) => option.id === inputTypeValue)}
                onChangeFunction={(option) => {
                  setFieldValue('inputType', option.id);
                  /** clear prSortOrder */
                  setFieldValue('prSortOrder', 0);
                  if (option.id === 'C' || option.id === 'T') {
                    setFieldValue('detailType', 'sets');
                    setFieldValue('detail', 0);
                  } else {
                    setFieldValue('detail', '');
                    setFieldValue('detailType', null);
                  }
                }}
                onBlur={() => setFieldTouched('inputType', true)}
                error={!!touched.inputType && !!errors.inputType}
                errorMsg={errors.inputType}
                title='Input Type'
                titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                customStyles={customSelectStylesLinkTo}
                isClearable={false}
                styledProps={{ height: '' }}
                width='100%'
                styledPropsInput={{
                  width: '100% !important',
                }}
              />
              {(inputTypeValue === 'R' || inputTypeValue === 'S') ? (
                <Input
                  disabled={modalData?.disabledEditModal}
                  error={!!touched.detail && !!errors.detail}
                  errorMsg={errors.detail}
                  fontSize='16px'
                  fontWeight={400}
                  textColor='#444444'
                  height='38px'
                  label='Time Limit'
                  name='detail'
                  onChange={(value) => {
                    handleChange(value);
                    setTouched({ detail: true });
                  }}
                  onBlur={handleBlur}
                  right='5px'
                  styledPropsLabel={{
                    fontSize: '16px',
                    fontWeight: 700,
                  }}
                  styledPropsWrapper={{
                    /** flex: 1, */
                  }}
                  top='38px'
                  value={detailValue}
                  width='100%'
                  placeholder={(inputTypeValue === 'R' || inputTypeValue === 'S') && '00:00'}
                />
              ) : (
                <CompleteContainerAndErrorWrapper>
                  <Text color={modalData?.disabledEditModal && '#BDBDBD'} fontSize='16px' fontWeight={700}>{inputTypeValue === 'T' ? `Complete ${detailTypeValue} for time` : 'Complete'}</Text>
                  <CompleteContainer touched={touched.detail} error={errors.detail}>
                    <SelectBox
                      isDisabled={modalData?.disabledEditModal}
                      removeSeparator
                      options={detailTypeOptions}
                      value={detailTypeOptions.find((option) => option.id === detailTypeValue)}
                      onChangeFunction={(option) => {
                        setFieldValue('detailType', option.id);
                      }}
                      onBlur={() => setFieldTouched('detailType', true)}
                      error={!!touched.detailType && !!errors.detailType}
                      errorMsg={errors.detailType}
                      titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                      customStyles={customSelectStylesLinkTo}
                      isClearable={false}
                      styledProps={{ height: '' }}
                      styledPropsInput={{
                        width: '100px !important',
                      }}
                      width='100px'
                    />
                    <Input
                      disabled={modalData?.disabledEditModal}
                      fontSize='16px'
                      fontWeight={400}
                      textColor='#444444'
                      height='38px'
                      name='detail'
                      onChange={(value) => {
                        handleChange(value);
                        setTouched({ detail: true });
                      }}
                      onBlur={handleBlur}
                      right='5px'
                      styledPropsLabel={{
                        fontSize: '16px',
                        fontWeight: 700,
                      }}
                      styledPropsWrapper={{
                        flex: 1,
                      }}
                      top='38px'
                      value={detailValue || ''}
                      width='100%'
                      placeholder={(inputTypeValue === 'R' || inputTypeValue === 'S') && '00:00'}
                    />
                  </CompleteContainer>
                  {!!touched.detail && !!errors.detail && (
                  <Text fontSize='13px' fontWeight={700} color='#CC0404' style={{ marginTop: '5px' }}>{errors.detail}</Text>
                  )}
                </CompleteContainerAndErrorWrapper>
              )}
            </InputTypeAndPRTrackingContainer>
          </OuterLinkContainer>
          {((inputTypeValue === 'R' && !!reusableItemValue) || (inputTypeValue === 'S' && !!reusableItemValue) || (inputTypeValue === 'T' && !!reusableItemValue)) && (
          <SelectBox
            isDisabled={modalData?.disabledEditModal}
            options={PRTrackingOptions}
            value={PRTrackingOptions.find((option) => option.id === prSortOrderValue)}
            onChangeFunction={(option) => {
              setFieldValue('prSortOrder', option.id);
            }}
            onBlur={() => setFieldTouched('prSortOrder', true)}
            error={!!touched.prSortOrder && !!errors.prSortOrder}
            errorMsg={errors.prSortOrder}
            title='PR Tracking'
            titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
            customStyles={customSelectStylesLinkTo}
            isClearable={false}
            styledProps={{ height: '' }}
            styledPropsInput={{
              width: '100% !important',
            }}
          />
          )}
          <DescriptionContainer>
            <Text
              fontSize='16px'
              fontWeight={700}
              color={modalData?.disabledEditModal && '#BDBDBD'}
            >
              Description
            </Text>
            <Field
              name='description'
              className='form-control'
              render={({ field }) => (
                <StyledTextArea disabled={modalData?.disabledEditModal} {...field} />
              )}
            />
            {errors.description && (
            <Text color='#CC0404' fontSize='13px' fontWeight={700} style={{ marginTop: '5px' }}>{errors.description}</Text>
            )}
          </DescriptionContainer>
          <AddAssetsColumn>
            <ResizeObserver
              onResize={(rect) => {
                setAddAssetsColumnContainerWidth(rect?.width);
              }}
            />
            {modalData?.disabledEditModal ? null : (
              <Text fontSize='16px' fontWeight={700}>Attach Document/Link</Text>
            )}
            {assetToAdd ? (
              <AssetButtonContainer onClick={() => {
                const docId = assetToAdd?.id;
                if (assetToAdd.type === 1) {
                  dispatch(fetchDocument(({ accountCode, docId }), {
                    onSuccess: (response) => {
                      window.open(response?.url, '_blank');
                    },
                    onError: () => {
                      toast.error('Opps! Something went wrong. Unable to fetch document.');
                    },
                  }));
                }
                if (assetToAdd.type === 2) {
                  window.open(assetToAdd?.url, '_blank');
                }
              }}
              >
                <ClearAssetIconContainer onClick={(e) => {
                  dispatch(addAsset(null));
                  setFieldValue('documentId', null);
                  e.stopPropagation();
                }}
                >
                  <IcomoonReact
                    iconSet={iconSet}
                    size={10}
                    icon='remove'
                    color='#9E9E9E'
                  />
                </ClearAssetIconContainer>
                <IcomoonReact
                  iconSet={iconSet}
                  size={14}
                  icon='link'
                  color='#9E9E9E'
                />
                <Text
                  style={{
                    maxWidth: `${addAssetsColumnContainerWidth - 60}px`,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                  fontSize='16px'
                  color='#9E9E9E'
                >
                  {assetToAdd?.name}
                </Text>
              </AssetButtonContainer>
            ) : (
              <>
                {!modalData?.disabledEditModal && (
                <AddAssetButtonContainer onClick={() => dispatch(setActiveSecondLayerModal('addAssetModal'))}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={12}
                    icon='plus'
                    color='#77A7FF'
                  />
                  <Text fontSize='16px' color='#77A7FF'>Add Asset</Text>
                </AddAssetButtonContainer>
                )}
              </>
            )}
          </AddAssetsColumn>
        </CircuitsInputsSubContainer>
      </CircuitsInputsRow>
      <AdditionalOptionsHeaderRow>
        <Seperator />
        <AdditionalOptionsTextAndArrowIconContainer onClick={() => setShowAdditionalOptions(!showAdditionalOptions)}>
          <Text fontSize='18px' color='#9E9E9E' style={{ minWidth: '210px' }}>Exercise Default Settings</Text>
          <IcomoonReact
            iconSet={iconSet}
            size={8}
            icon={showAdditionalOptions ? 'up-arrow' : 'down-arrow'}
            color='#9E9E9E'
          />
        </AdditionalOptionsTextAndArrowIconContainer>
        <Seperator />
      </AdditionalOptionsHeaderRow>
      {showAdditionalOptions && (
        <Text fontSize='14px' color='#757575' style={{ marginTop: '-8px' }}>Any items checked below will be active when adding this exercise to a workout</Text>
      )}
      <AdditionalOptionsWrapper showAdditionalOptions={showAdditionalOptions}>
        <LabelAndCheckBoxContainerWrapper showAdditionalOptions={showAdditionalOptions}>
          {/* <Text fontWeight={700} fontSize='16px' color={modalData?.disabledEditModal && '#BDBDBD'}>Athlete Input</Text> */}
          <CheckBoxRow>
            {AthleteInputCheckBoxDataArray.map((option) => (
              <NameAndInputContainer disabled={modalData?.disabledEditModal}>
                <input
                  disabled={modalData?.disabledEditModal}
                  className='checkbox-input'
                  type='checkbox'
                  name={option.name}
                  onChange={() => {
                    setFieldValue(`${option.name}`, !option.checked);
                  }}
                  checked={option.checked}
                />
                <Text color={modalData?.disabledEditModal && '#BDBDBD'} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>{option.label}</Text>
              </NameAndInputContainer>
            ))}
          </CheckBoxRow>
        </LabelAndCheckBoxContainerWrapper>
      </AdditionalOptionsWrapper>
    </CircuitsInputsContainer>
  );
};

export default CircuitsFormInputs;
